import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';
import { storeAsync } from '../../app-module';
const RegistersTypeList = () => import('@/modules/registers-type/pages/RegistersTypeList.vue');
const getRegistersTypeModule = () => import('@/modules/registers-type/registers-type-store');
const importRegistersTypeStore = () =>
    getRegistersTypeModule().then((storeModule) => {
        if (!storeAsync().hasModule('registersType')) storeAsync().registerModule('registersType', storeModule.default);
        else return;
    });

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'registersType',
                path: '/register-type',
                component: RegistersTypeList,
                meta: {
                    auth: true,
                    permission: Permissions.values.registersViewAll,
                },
                beforeEnter: (to, from, next) => {
                    importRegistersTypeStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'registersType',
                path: '/registers-type/org',
                component: RegistersTypeList,
                meta: {
                    auth: true,
                    permission: Permissions.values.registersTypeRead,
                },
                beforeEnter: (to, from, next) => {
                    importRegistersTypeStore().then(() => {
                        next();
                    });
                },
            },            
        ],
    },
];
